import {
  FETCH_USER_DATA_SUCCESS,
} from '../actions/types/UserActionTypes';
import { AUTH_LOGOUT } from '../../../redux/actions/types/authActionTypes';

export const initialState = {
  userInfo: [],
  userName: '',
};

const handleFetchUserInfoSuccess = (action, state) => ({
  ...state,
  userInfo: [...action.payload.userInfo.roles],
  userName: action.payload.userInfo.name,
});

const userDataReducer = (state = initialState, action) => {
  switch (action.type) {
  case FETCH_USER_DATA_SUCCESS:
    return handleFetchUserInfoSuccess(action, state);
  case AUTH_LOGOUT:
    return initialState;
  default:
    return state;
  }
};

export default userDataReducer;
